<template lang="pug">
  #overlay-weight-scale-with-selfie
    icon(data="@icon/overlay/evidence-guideline-weight.svg")
    icon(data="@icon/overlay/evidence-guideline-face.svg")
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
